import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Router } from "@angular/router";
import { CONST_URL_SEGEMENTS } from "@fitness-force/constants";
import { AppErrors, ConflictError, NotFoundError } from '@fitness-force/models';;
import type { CreateOpportunityRequest, UpdateOpportunityRequest } from '@fitness-force/models';
import { environment } from '@fitness-force/environments';
import { throwError,  Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { OpportunityBoardType } from "@fitness-force/enum";
import type { CreateResponse } from '@fitness-force/models';




@Injectable({
  providedIn: 'root'
})
export class OpportunityService {
  private http = inject(HttpClient);
  private router = inject(Router);


  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
    }

  //tenants/{tenant_id:int}/boards/{board_id:int}/opportunities
  OpportunityCreateService(tenantId: number, boardType: OpportunityBoardType, createOpportunityRequest: CreateOpportunityRequest) {

    return this.http.post(environment.BASE_URL + CONST_URL_SEGEMENTS.OPPORTUNITY.CREATE_OPPORTUNITY
      .replace('{tenant_id}', tenantId.toString())
      .replace('{board_type}', boardType.toString()),createOpportunityRequest, this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {

          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          else if (error.status === 409) {
            return throwError(() => new ConflictError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  OpportunityUpdateService(tenantId: number, boardType: OpportunityBoardType,oppId: number, updateOpportunityRequest: UpdateOpportunityRequest, ): Observable<CreateResponse> {
    return this.http.put(environment.BASE_URL + CONST_URL_SEGEMENTS.OPPORTUNITY.UPDATE_OPPORTUNITY
      .replace('{tenant_id}', tenantId.toString())
      .replace('{board_type}', boardType.toString())
      .replace('{opp_id}', oppId.toString())
      , updateOpportunityRequest,this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }


  //tenants/{tenant_id:int}/boards/{board_id:int}/opportunities
  OpportunityGetService(tenantId: number, boardType: OpportunityBoardType, oppId: number): Observable<Response> {
    return this.http.get(
      environment.BASE_URL + CONST_URL_SEGEMENTS.OPPORTUNITY.GET_OPPORTUNITY
        .replace('{tenant_id}', tenantId.toString())
        .replace('{board_type}', boardType.toString())
        .replace('{opp_id}', oppId.toString()), { headers: this.httpOptions.headers }
    )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  OpportunityDeleteService(tenantId: number, boardType:any, oppId: number) {
    return this.http.delete(
      environment.BASE_URL + CONST_URL_SEGEMENTS.OPPORTUNITY.DELETE_OPPORTUNITY
        .replace('{tenant_id}', tenantId.toString())
        .replace('{board_type}', boardType.toString())
        .replace('{opp_id}', oppId.toString()), { headers: this.httpOptions.headers }
    )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          else {
            return throwError(() => new AppErrors(error));
          }
        })
      );
  }

  OpportunityStageChange(tenantId: number, boardType: OpportunityBoardType, oppId: number, stageMstId: number) {
    return this.http.post(
      environment.BASE_URL + '/tenants/' + tenantId + '/boards/' + boardType + '/' + CONST_URL_SEGEMENTS.OPPORTUNITY.OPPORTUNITY + '/' + oppId, { headers: this.httpOptions.headers }
    ).pipe(
      map((res: any) => {
        return res;
      })
      , catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        }
        else {
          return throwError(() => new AppErrors(error));
        }
      })
    );
  }

  OpportunityMarkAsLost(tenantId: number, boardType: OpportunityBoardType, oppId: number, lostDealData:any) {
    return this.http.post(
      environment.BASE_URL + CONST_URL_SEGEMENTS.OPPORTUNITY.MARK_AS_LOST
        .replace('{tenant_id}', tenantId.toString())
        .replace('{board_type}', boardType.toString())
        .replace('{opp_id}', oppId.toString()),lostDealData, this.httpOptions
    ).pipe(
      map((res: any) => {
        return res;
      })
      , catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        }
        else {
          return throwError(() => new AppErrors(error));
        }
      })
    );
  }


  OpportunityMarkAsWon(tenantId: number, boardType: OpportunityBoardType, oppId: number) {
    return this.http.post(
      environment.BASE_URL + CONST_URL_SEGEMENTS.OPPORTUNITY.MARK_AS_WON
        .replace('{tenant_id}', tenantId.toString())
        .replace('{board_type}', boardType.toString())
        .replace('{opp_id}', oppId.toString()), { headers: this.httpOptions.headers }
    ).pipe(
      map((res: any) => {
        return res;
      })
      , catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        }
        else {
          return throwError(() => new AppErrors(error));
        }
      })
    );
  }

  OpportunityMarkAsNurture(tenantId: number, boardType: OpportunityBoardType, oppId: number) {
    return this.http.post(
      environment.BASE_URL + CONST_URL_SEGEMENTS.OPPORTUNITY.MARK_AS_NURTURE
        .replace('{tenant_id}', tenantId.toString())
        .replace('{board_type}', boardType.toString())
        .replace('{opp_id}', oppId.toString()), { headers: this.httpOptions.headers }
    ).pipe(
      map((res: any) => {
        return res;
      }), catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        }
        else {
          return throwError(() => new AppErrors(error));
        }
      })
    );
  }

  getOpportunityService(tenantId: number, boardType: OpportunityBoardType,allParams:any=null): Observable<Response> {
    let parsedParams = new HttpParams()
    if(allParams){
      allParams.forEach((p: any) => {
        parsedParams = parsedParams.append(p.name, p.value);
      });
    }
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.OPPORTUNITY.GET_OPPORTUNITIES
      .replace('{tenant_id}', tenantId.toString())
      .replace('{board_type}', boardType.toString());
    return this.http.get(url, {
      headers: this.httpOptions.headers, params: parsedParams
    })
      .pipe(
        map((res: any) => {
          return res.items;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  OpportunityChangeStageService(tenantId: number, boardType: OpportunityBoardType, opp_id: number, stg_master_id:number,payload:any): Observable<Response> {

    return this.http.post(environment.BASE_URL + CONST_URL_SEGEMENTS.OPPORTUNITY.CHANGE_STAGE
      .replace('{tenant_id}', tenantId.toString())
      .replace('{board_type}', boardType.toString())
      .replace('{opp_id}', opp_id.toString())
      .replace('{stage_id}', stg_master_id.toString()), payload)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  OpportunityChangeOrderService(tenantId: number, boardType: OpportunityBoardType, opp_id: number,data:any): Observable<Response> {

    return this.http.post(environment.BASE_URL + CONST_URL_SEGEMENTS.OPPORTUNITY.CHANGE_ORDER
      .replace('{tenant_id}', tenantId.toString())
      .replace('{board_type}', boardType.toString())
      .replace('{opp_id}', opp_id.toString()),data)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }
}
